import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'

var serviceName = 'siteNumberRequestService'
var path = '/SiteNumberRequest/'
var isDebug = false

function put (http, siteNumberRequest) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, siteNumberRequest)
}

function search (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'search')
    return http.post(path + 'Search', searchDto).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
            })
        }
        return response
    })
}

function todo (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'todo')
    return http.post(path + 'Todo', searchDto).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
            })
        }
        return response
    })
}

function get (http, siteNumberRequestId) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?siteNumberRequestId=' + siteNumberRequestId)
}

function searchCompleted (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'search')
    return http.post(path + 'SearchCompleted', searchDto).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.createdDate = dateService.convertToDate(x.createdDate)
            })
        }
        return response
    })
}

export default {
    put: put,
    search: search,
    get: get,
    todo: todo,
    searchCompleted: searchCompleted
}



// WEBPACK FOOTER //
// ./src/services/siteNumberRequestService.js